import { render } from "./Modal.vue?vue&type=template&id=6471539f&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6471539f&scoped=true&lang=css"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6471539f"]])

export default __exports__